<template>
	<div class="main">
		<ul id="dormitoryTypeNav" class="nav nav-tabs" role="tablist" v-show="isAdmin('stay')">
			<li class="" data-apply-type="N" role="presentation" v-if="normalIsOpen">
				<a data-toggle="tab" @click="selectListTab('N')">一般宿舍</a>
			</li>
			<li class="" data-apply-type="V" role="presentation" v-if="vacationIsOpen">
				<a data-toggle="tab" @click="selectListTab('V')">寒暑假宿舍</a>
			</li>
			<li class="" data-apply-type="S" role="presentation" v-if="specialIsOpen">
				<a data-toggle="tab" @click="selectListTab('S')">特殊原因宿舍</a>
			</li>
			<li class="" id="qrcodeSettingTab" role="presentation" v-if="isAdmin('stay')">
				<a data-toggle="tab" @click="selectQrcodeTab()">QRCode 設定</a>
			</li>
		</ul>
		<section class="panel panel-default" style="margin-bottom: 0px;" v-if="isAdmin('stay')" v-show="activeTab === 'list'">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4" v-if="dormitoryType == 'N'">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<multiselect v-model="selectedSmtrOptions" :options="selectYear()" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="請選擇學期" label="text" track-by="value" :preselect-first="false" selectedLabel="V" selectLabel="" deselectLabel="">
									</multiselect>
								</div>
							</div>
							<div class="col-md-4" v-else>
								<label class="col-md-4">學年</label>
								<div class="col-md-8">
									<multiselect v-model="selectedSmtrOptions" :options="selectYear()" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="請選擇學年" label="text" track-by="value" :preselect-first="false" selectedLabel="V" selectLabel="" deselectLabel="">
									</multiselect>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學制</label>
								<div class="col-md-8">
									<select v-model="deptSsym" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in ssymList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">系科</label>
								<div class="col-md-8">
									<select v-model="deptCode" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in deptList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">年級</label>
								<div class="col-md-8">
									<select v-model="drade" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="d in 7" :key="d" :value="d">{{d}}年級</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學生狀態</label>
								<div class="col-md-8">
									<select v-model="state" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(item, index) in stateList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="account" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">姓名</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="name" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">身分別</label>
								<div class="col-md-8">
									<select v-model.number="stuIdentity" class="form-control">
										<option :value="null">--請選擇--</option>
										<option v-for="(item, index) in identiList" :key="index" :value="item.commCode">{{item.commValue}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">宿舍</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedFloor" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">寢室</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedRoom" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">繳費狀態</label>
								<div class="col-md-8">
									<select v-model="paymentStatusQry" class="form-control">
										<option value="">--請選擇--</option>
										<option value="BILLING">進入繳費</option>
										<option value="OVERDUE">逾期繳費</option>
										<option value="PAID">繳費完成</option>
										<option value="QUIT">切結書</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-4 "></div>
						<div class="col-md-4 ">
							<div class="col-xs-5 col-md-4">
								<button type="button" class="btn btn-default btn-block" @click="clearSearchParam()">清除</button>
							</div>
							<div class="col-xs-2 col-md-4"></div>
							<div class="col-xs-5 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
						<div class="col-md-4 "></div>
					</div>
				</div>
			</div>
		</section>
		<div v-if="activeTab === 'qrcode'">
			<qrcode-setting-panel scene-title="入宿" scene-key="CHECKIN" :enable-open="true" :show-enabled="false"></qrcode-setting-panel>
		</div>
		<div id="dormitoryTypeContent" class="tab-content" v-show="activeTab === 'list'">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
			<div class="row form-group">
				<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">

					<button class="btn btn-danger hidden-xs" @click="exportManifest">下載清冊</button>
					<button class="btn btn-danger btn-block visible-xs" @click="exportManifest">下載清冊</button>

					<button class="btn btn-danger hidden-xs" v-if="sessionData.accountType == 'ADM'" @click="exportBankText">銀行檔匯出</button>
					<button class="btn btn-danger btn-block visible-xs" v-if="sessionData.accountType == 'ADM'" @click="exportBankText">銀行檔匯出</button>

					<button class="btn btn-danger hidden-xs" @click="exportExcel">資料匯出</button>
					<button class="btn btn-danger btn-block visible-xs" @click="exportExcel">資料匯出</button>
					<label for="fileV" class="btn btn-danger hidden-xs">資料匯入</label>
					<label for="fileV" class="btn btn-danger btn-block visible-xs">資料匯入</label>
					<input id="fileV" ref="fileV" name="file" type="file" value accept=".xls, .xlsx" @change="uploadFile($event)" style="display: none" />

				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
				<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
					<thead>
						<tr v-if="sessionData.accountType === 'STU'">
							<th class="text-center" style="width:9%">申請類別</th>
							<th class="text-center" style="width:4%">學期</th>
							<th class="text-center" style="width:9%">學制</th>
							<th class="text-center" style="width:12%">系科年級</th>
							<th class="text-center" style="width:6%">學生狀態</th>
							<th class="text-center" style="width:8%">學號</th>
							<th class="text-center" style="width:7%">姓名</th>
							<th class="text-center" style="width:6%">身分別</th>
							<th class="text-center" style="width:8%">分配床位</th>
							<th class="text-center" style="width:8%">繳費狀態</th>
              				<th class="text-center" style="width:5%">繳費金額</th>
							<th class="text-center" style="width:6%"></th>
							<th class="text-center" style="width:6%"></th>
							<th class="text-center" style="width:6%"></th>
						</tr>
						<tr v-if="isAdmin('stay')">
							<th class="text-center" style="width:8%">申請類別</th>
							<th class="text-center" style="width:5%">學期</th>
							<th class="text-center" style="width:8%">學制</th>
							<th class="text-center" style="width:13%">系科年級</th>
							<th class="text-center" style="width:5%">學生狀態</th>
							<th class="text-center" style="width:7%">學號</th>
							<th class="text-center" style="width:7%">姓名</th>
							<th class="text-center" style="width:6%">身分別</th>
							<th class="text-center" style="width:13%">分配床位</th>
							<th class="text-center" style="width:8%">繳費狀態</th>
							<th class="text-center" style="width:5%">繳費金額</th>
							<th class="text-center" style="width:8%"></th>
							<th class="text-center" style="width:8%">報到時間</th>
						</tr>
					</thead>
					<tbody v-for="(item, index) in roomApplyList.rows" :key="index">
						<tr>
							<td class="text-center" data-title="申請類別">{{getDormitoryTypeStr(item.dormitoryType)}}</td>
							<td class="text-center" data-title="學期">{{item.smtr}}</td>
							<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
							<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
							<td class="text-center" data-title="學生狀態">{{item.stateStr}}</td>
							<td class="text-center" data-title="學號">{{item.account}}</td>
							<td class="text-center" data-title="姓名">{{item.name}}</td>
							<td class="text-center" data-title="身分別">{{item.stuIdentityStr}}</td>
							<td class="text-center" data-title="分配床位" >
								<span v-if="item.bedRoom !== null">{{item.bedFloor}}-{{item.bedRoom}}-{{item.bed}}<br/>{{item.bedCategory}}</span>
								<br v-if="canManualEditBed(item)">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="canManualEditBed(item)" @click="openManualBedEdit(item)">修改床位</a>
							</td>
							<td class="text-center" data-title="繳費狀態" >
								<a :href="$baseUrl + '/upload/' + item.quitProve" target="_blank" style="color: #337ab7" v-if="item.writeOffStatus == 'N' && item.quitProve">切結書</a>
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;"  @click="openBillingInvoice(item.id, item.idno, item.account, item.smtr, item.dormitoryType)"
                   v-else-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve && (new Date(item.paymentEndDate).setDate(new Date(item.paymentEndDate).getDate() + 1)) > new Date()">進入繳費</a>
                <span v-else-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve && (new Date(item.paymentEndDate).setDate(new Date(item.paymentEndDate).getDate() + 1)) <= new Date()">逾期繳費</span>
								<span v-else-if="item.writeOffStatus == 'Y'">{{item.writeOffStatusStr}}</span>
                <div v-if="accountType === 'STU' && item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve">
                  <a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;"  @click="openWriteOffProve(item)">{{item.writeOffProveFile ? "繳費證明" : "上傳繳費證明"}}</a>
                </div>
							</td>
              <td class="text-center" data-title="繳費金額" >
                {{item.writeOffAmount ? item.writeOffAmount : ""}}
              </td>
              <td class="text-center" data-title="手動銷帳" v-if="isAdmin('stay')">
                <a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="item.writeOffStatus == 'N' && item.bankBarcode_1 && !item.quitProve" @click="openWriteOffProve(item)">手動銷帳</a>
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="item.writeOffProveFile" @click="openWriteOffProve(item)">{{item.writeOffStatus == 'N' ? "已上傳證明" : "銷帳完成"}}</a>
              </td>
				<td class="text-center" data-title="報到時間" v-if="isAdmin('stay')">
					{{item.reportDateCht}}
				</td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y'" @click="gotoView('stay.intoRoomData', { id:item.id, idno: item.idno, account: item.account })">入宿</a>
							</td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y' && (!item.leaveStatus || item.leaveStatus == 'R')" @click="gotoView('stay.leave.apply', { leaveType:'C', id:item.id, idno: item.idno, account: item.account })">退宿申請</a>
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="item.leaveType == 'C' && (item.leaveStatus && item.leaveStatus != 'N')" @click="gotoView('stay.leave.apply', { leaveType:'C', id:item.id, idno: item.idno, account: item.account })">{{item.leaveStatus == 'Y' ? "退宿":"退宿申請中"}}</a>
							</td>
							<td class="text-center" data-title="" v-if="accountType === 'STU'">
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="isIntoRoom(item) && item.isLeave != 'Y' && leaveIsOpen && (!item.leaveStatus || item.leaveStatus == 'R')" @click="gotoView('stay.leave.apply', { leaveType:'L', id:item.id, idno: item.idno, account: item.account })">離宿申請</a>
								<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" v-if="item.leaveType == 'L' && (item.leaveStatus && item.leaveStatus != 'N')" @click="gotoView('stay.leave.apply', { leaveType:'L', id:item.id, idno: item.idno, account: item.account })">{{item.leaveStatus == 'Y' ? "離宿":"離宿申請中"}}</a>
							</td>
						</tr>
						<tr v-if="item.writeOffStatus != 'Y' && item.bankBarcode_1 && accountType == 'STU'">
							<td colspan="15">
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<b>是否放棄入住宿舍?</b>
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<a href="javascript:;" target="_blank" style="color: #337ab7" @click="downloadFile('放棄住宿切結書.pdf')">放棄住宿切結書格式</a>
										, 請下載使用！
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<b>上傳放棄住宿切結書</b>
									</div>
								</div>
								<div class="col-md-12 table-bordered p-sm">
									<div class="form-group">
										<input type="file" name="quitProve" ref="quitProve" @change="getQuitProve($event, item)" />
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				</div>
				<div class="col-md-12">
					<div class="text-center" v-if="isAdmin('stay')">
						<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
					</div>
				</div>
			</div>
			</div>
		</div>
		<billingInvoicePopup v-if="isOpenBillingInvoice" v-bind:id="popupParam.id" v-bind:idno="popupParam.idno" v-bind:account="popupParam.account" v-bind:smtr="popupParam.smtr" v-bind:dormitoryType="popupParam.dormitoryType" />
    <stayWriteOffProve v-if="isOpenStayWriteOffProve" v-bind:id="popupParam.id" v-bind:writeOffProve="popupParam.writeOffProveFile" v-bind:writeOffType="popupParam.writeOffType" v-bind:totalAmount="popupParam.totalAmount" v-bind:writeOffDt="popupParam.writeOffDate"/>
		<manualBedEdit v-if="isOpenManualBedEdit" v-bind:bedForm="manualBedForm" />
	</div>
</template>
<script>
import billingInvoicePopup from './billingInvoice.vue';
import manualBedEdit from './manualBedEdit.vue';
import stayWriteOffProve from "@/components/popup/stayWriteOffProve";
import Multiselect from 'vue-multiselect';
import qrcodeSettingPanel from '../common/qrcodeSettingPanel.vue';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
	components:{
		billingInvoicePopup,
		manualBedEdit,
    stayWriteOffProve,
    Multiselect,
		qrcodeSettingPanel
	},
	data() {
		return {
			dormitoryType: "N",
			activeTab: "list",
			arimId: "",
			normalIsOpen: true,
			vacationIsOpen: true,
			specialIsOpen: true,
			leaveIsOpen:false,
			isDefault: true,
			importExcelFile: "",
			accountType: "",
			quitProveView: true,
			roomApplyList: {},
			quitProveFile: null,
			account: "",
			name: "",
			smtr: "",
			smtrList: [],
			idno: "",
			deptSsym: "",
			deptCode: "",
			drade: "",
			state: "",
			stuIdentity: null,
			paymentStatusQry: "",
			deptList: [],
			stateList: [],
			identiList: [],
			apysList: [],
			ssymList: [],
			page: 1,
			totalPage: 1,
			isOpenBillingInvoice:false,
			isOpenManualBedEdit:false,
      isOpenStayWriteOffProve:false,
			popupParam:{
				id:"",
				idno:"",
				account:"",
				smtr:"",
				dormitoryType:"",
        writeOffProveFile:"",
        writeOffType:null,
        totalAmount:0,
        writeOffDate:''
			},
			manualBedForm: {
				id: "",
				bedFloor: "",
				bedRoom: "",
				bed: "",
				bedCategory: "",
				infoBoxNo: "",
				ipAddr: ""
			},
			bedFloor:"",
			bedRoom:"",
		};
	},
	computed: {
		selectedSmtrOptions: {
			get() {
				const options = this.selectYear();
				return options.filter(o => this.smtrList.includes(o.value));
			},
			set(val) {
				this.smtrList = val.map(o => o.value);
			}
		}
	},
	mounted() {
		if (this.sessionData == null) {
			this.$router.replace({ path: "/" });
		}
		this.accountType = this.sessionData.accountType;

		// 載入下拉選單資料
		const apiInit = "/api/Room/stayInit";
		this.$axios.post(apiInit).then(resp =>{
			this.deptList = resp.data.data.deptList;
			this.stateList = resp.data.data.stateList;
			this.identiList = resp.data.data.identiList;
			this.apysList = resp.data.data.apysList;
			this.ssymList = resp.data.data.ssymList;
		});

    //套用查詢設定
    const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));

    if(storeQryParam != null) {
      this.dormitoryType = storeQryParam.dormitoryType;
      this.bedFloor = storeQryParam.bedFloor;
      this.bedRoom = storeQryParam.bedRoom;
      this.smtrList = storeQryParam.smtrList || [];
      this.account = storeQryParam.account;
      this.name = storeQryParam.name || "";
      this.deptSsym = storeQryParam.deptSsym || "";
      this.deptCode = storeQryParam.deptCode || "";
      this.drade = storeQryParam.drade || "";
      this.state = storeQryParam.state || "";
      this.stuIdentity = storeQryParam.stuIdentity || null;
      this.paymentStatusQry = storeQryParam.paymentStatusQry || "";
    }
    const storePage = this.getStore(`${this.$route.name}.page`);
    if(storePage != null) {
      this.page = storePage;
    }

    switch (this.dormitoryType) {
      case "V":
        document.querySelector("[id='dormitoryTypeNav']").children[1].classList.add("active");
        break;
      case "S":
        document.querySelector("[id='dormitoryTypeNav']").children[2].classList.add("active");
        break;
      case "N":
      default:
        document.querySelector("[id='dormitoryTypeNav']").children[0].classList.add("active");
        break;
    }
		this.itemIsOpening();
		this.selectionDoemitoryType(this.dormitoryType, false);

	},
	methods: {
		buildQueryParam() {
			if (this.isAdmin('stay')) {
				return {
					smtrList:this.smtrList,
					dormitoryType: this.dormitoryType,
					account:this.account,
					name:this.name,
					deptSsym:this.deptSsym,
					deptCode:this.deptCode,
					drade:this.drade,
					state:this.state,
					stuIdentity:this.stuIdentity,
					paymentStatusQry:this.paymentStatusQry,
					applyStatus: "Y",
					bedFloor:this.bedFloor,
					bedRoom:this.bedRoom,
					qualification: "Q",
				};
			}

			return {
				account: this.sessionData.account,
				qualification: "Q",
				applyStatus: "Y"
			};
		},
		selectListTab(dormitoryType) {
			this.activeTab = 'list';
			document.getElementById('qrcodeSettingTab').classList.remove('active');
			this.selectionDoemitoryType(dormitoryType);
		},
		selectQrcodeTab() {
			this.activeTab = 'qrcode';
			const nav = document.getElementById('dormitoryTypeNav');
			if (nav) {
				Array.from(nav.querySelectorAll('li[data-apply-type]')).forEach(li => li.classList.remove('active'));
			}
		},
		selectionDoemitoryType(dormitoryType, clearQueryParam = true) {
			this.dormitoryType = dormitoryType;
      if(clearQueryParam) {
        this.bedFloor = "";
        this.bedRoom = "";
        this.account = "";
        this.name = "";
        this.deptSsym = "";
        this.deptCode = "";
        this.drade = "";
        this.state = "";
        this.stuIdentity = null;
        this.paymentStatusQry = "";
        if(this.dormitoryType == "N"){
          this.smtrList = [this.nowSmtr];
        }else {
          this.smtrList = [`${this.nowSyear}`];
        }
      } else {
        if(this.dormitoryType == "N" && (!this.smtrList || this.smtrList.length == 0)){
          this.smtrList = [this.nowSmtr];
        }else if ((this.dormitoryType == "V" || this.dormitoryType == "S" ) && (!this.smtrList || this.smtrList.length == 0)) {
          this.smtrList = [`${this.nowSyear}`];
        }
      }
			this.loadGrid();
		},
		loadGrid(){
			const qryParam = this.buildQueryParam();
			const api = "/api/Room/roomApplyList";
			let _this = this;
			this.$axios.post(api, JSON.stringify({
				model:qryParam,
				page: this.page,
				pageSize: 10,
				sortColumn:"BED_FLOOR, BED_ROOM, BED, BED_CATEGORY"
			})).then(resp => {
				_this.roomApplyList = resp.data.data;
				_this.totalPage = _this.roomApplyList.total;
				_this.page = _this.roomApplyList.page;
			});
		},
		itemIsOpening(){
			const apiSetting = "/api/Common/roomTimeSettingByType/";
			this.$axios.post(apiSetting).then(resp =>{
				if(resp.data.status == "success"){
					let tmp = resp.data.data.filter(item => {
						return item.key == "L"
					});
					if(tmp.length > 0){
						this.leaveIsOpen = tmp[0].value == "Y";
					}
				}
			});
		},
		canManualEditBed(item) {
			return this.isAdmin('stay') && item.writeOffStatus == "Y" && item.bedRoom !== null && item.quitProve === null;
		},
		openManualBedEdit(item) {
			this.manualBedForm = {
				id: item.id,
				bedFloor: item.bedFloor || "",
				bedRoom: item.bedRoom || "",
				bed: item.bed || "",
				bedCategory: item.bedCategory || "",
				infoBoxNo: item.infoBoxNo || "",
				ipAddr: item.ipAddr || ""
			};
			this.isOpenManualBedEdit = true;
		},
		closeManualBedEdit() {
			this.isOpenManualBedEdit = false;
			this.manualBedForm = {
				id: "",
				bedFloor: "",
				bedRoom: "",
				bed: "",
				bedCategory: "",
				infoBoxNo: "",
				ipAddr: ""
			};
		},
		saveManualBedEdit(form) {
			const requiredFields = [form.bedFloor, form.bedRoom, form.bed, form.bedCategory, form.infoBoxNo, form.ipAddr];
			if (requiredFields.some(value => !value || !String(value).trim())) {
				bootbox.alert("請確認床位資料欄位皆已填寫");
				return;
			}

			const api = "/api/Room/updateAssignedBed";
			const payload = {
				id: form.id,
				bedFloor: form.bedFloor.trim(),
				bedRoom: form.bedRoom.trim(),
				bed: form.bed.trim(),
				bedCategory: form.bedCategory.trim(),
				infoBoxNo: form.infoBoxNo.trim(),
				ipAddr: form.ipAddr.trim()
			};

			this.$axios.post(api, payload).then(resp => {
				bootbox.alert(resp.data.msg);
				if (resp.data.status === "success") {
					this.closeManualBedEdit();
					this.loadGrid();
				}
			});
		},

		setDoemitoryType(dormitoryType) {
			this.dormitoryType = dormitoryType;
		},
		updateGrid(page) {
			this.page = page;
			this.loadGrid();
		},
		uploadFile(e) {
			this.importExcelFile = "";
			this.importExcelFile = e.target.files[0];
			this.importExcel(e);
		},
		importExcel(e) {
			const api = "/api/Room/importIntoRoomExcel";
			let formData = new FormData();
			formData.append("file", this.importExcelFile);
			formData.append("dormitoryType",this.dormitoryType);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				} else {
					bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
				}
				this.selectionDoemitoryType(this.dormitoryType);
			});
			e.target.value = "";
		},
		exportExcel() {
			const api = "/api/Room/exportIntoRoomExcel";
			this.$axios.post( api, JSON.stringify({
				dormitoryType: this.dormitoryType,
        smtrList: this.smtrList,
			}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "房間分配_"+this.customFormatter(new Date(),"YYYYMMDD")+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		exportManifest() {
			const api = "/api/Room/exportAssignRoomManifest";
			this.$axios.post(api, JSON.stringify(this.buildQueryParam()), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "宿舍清冊_"+this.customFormatter(new Date(),"YYYYMMDD")+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
		exportBankText(){
			const api = "/api/Room/exportToBankTxt/"+this.dormitoryType;
			this.$axios.post( api, JSON.stringify({}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "銀行_"+this.customFormatter(new Date(),"YYYYMMDD")+".txt");
				document.body.appendChild(link);
				link.click();
			});
		},
		getQuitProve(e, item) {
			this.quitProveFile = null;
			this.quitProveFile = e.target.files[0];
			this.uploadFileQuitProve(e, item);
		},
		uploadFileQuitProve(e, item) {
			const api = `/api/Room/giveUpRoomApply/${item.id}`;
			let formData = new FormData();
			formData.append("quitProveFile", this.quitProveFile);
			this.$axios.post(api, formData).then(resp => {
				if (resp.data.status === "success") {
					bootbox.alert(resp.data.msg);
					this.selectionDoemitoryType(this.dormitoryType);
				} else {
					bootbox.alert(resp.data.msg);
				}
			});

			e.target.value = "";
		},
		openBillingInvoice(id, idno, account, smtr, dormitoryType){
			this.popupParam.id = id;
			this.popupParam.idno = idno;
			this.popupParam.account=account;
			this.popupParam.smtr = smtr;
			this.popupParam.dormitoryType=dormitoryType;
			this.showPopupControl(true);
		},
		showPopupControl(isOpen){
			this.isOpenBillingInvoice = isOpen;
		},
		isIntoRoom(item){
			return item.writeOffStatus == "Y" && item.isLeave == "N";
		},
    openWriteOffProve(item){
      this.popupParam.id = item.id;
      this.popupParam.writeOffProveFile = item.writeOffProveFile;
      this.popupParam.writeOffType = item.writeOffType;
      this.popupParam.totalAmount = item.roomAmt + item.ensureAmt;
      this.popupParam.writeOffDate = item.writeOffDate;
      this.isOpenStayWriteOffProve = true;
    },
		getDormitoryTypeStr(dormitoryType){
			let str = "";
			if(dormitoryType == "N"){
				str = "一般宿舍";
			}else if(dormitoryType == "S"){
				str = "特殊宿舍";
			}else if(dormitoryType == "V"){
				str = "寒暑假宿舍";
			}
			return str;
		},
		selectYear(){
			let smtrArray = [];
			for(let y = parseInt(this.applySmtr.substring(0,3)); y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
		clearSearchParam(){
			this.smtrList = [];
			this.account = "";
			this.name = "";
			this.deptSsym = "";
			this.deptCode = "";
			this.drade = "";
			this.state = "";
			this.stuIdentity = null;
			this.paymentStatusQry = "";
			this.bedFloor = "";
			this.bedRoom = "";
			this.removeStore(`${this.$route.name}.qryParam`);
			this.removeStore(`${this.$route.name}.page`);
		},
	},
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.leave.apply" || to.name === "stay.intoRoomData") {
      this.setStore(`${this.$route.name}.qryParam`, {
        dormitoryType: this.dormitoryType,
        smtrList: this.smtrList,
        account: this.account,
        name: this.name,
        deptSsym: this.deptSsym,
        deptCode: this.deptCode,
        drade: this.drade,
        state: this.state,
        stuIdentity: this.stuIdentity,
        paymentStatusQry: this.paymentStatusQry,
        bedFloor :this.bedFloor,
        bedRoom: this.bedRoom
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
};
</script>
<style scoped>
/* 讓 vue-multiselect 符合 Bootstrap 3 form-control 樣式 */
::v-deep .multiselect {
  min-height: 34px;
  font-size: 14px;
}
::v-deep .multiselect__tags {
  min-height: 34px;
  padding: 4px 40px 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}
::v-deep .multiselect__tags .multiselect__tag {
  background: #d9534f;
  color: #fff;
  margin-bottom: 2px;
  padding: 3px 26px 3px 8px;
  font-size: 13px;
}
::v-deep .multiselect__tags .multiselect__tag-icon:after {
  color: #fff;
}
::v-deep .multiselect__tags .multiselect__tag-icon:hover {
  background: #c9302c;
}
::v-deep .multiselect__select {
  height: 32px;
}
::v-deep .multiselect__placeholder {
  color: #999;
  padding-top: 2px;
  margin-bottom: 0;
  font-size: 14px;
}
::v-deep .multiselect__input,
::v-deep .multiselect__single {
  font-size: 14px;
  padding: 0;
  margin-bottom: 0;
  line-height: 24px;
}
::v-deep .multiselect__option--highlight {
  background: #d9534f;
}
::v-deep .multiselect__option--highlight::after {
  background: #d9534f;
}
::v-deep .multiselect__option--selected.multiselect__option--highlight {
  background: #c9302c;
}
::v-deep .multiselect__option--selected.multiselect__option--highlight::after {
  background: #c9302c;
}
::v-deep .multiselect--active .multiselect__tags {
  border-color: #66afe9;
  box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}
</style>
